export default __webpack_public_path__ + "static/media/NoCam.b6e2b1e5.png";